// extracted by mini-css-extract-plugin
export default {"fadein":"WvGCdSyuttLZNU4OFMyT","app":"NJQQODlEuvSmz7S9AwOQ"};